import React, { useState } from 'react';
import Navbar from '../../containers/Navbar/Navbar';
import CircularSpinner from '../../utils/CircularSpinner';
import {useDispatch} from 'react-redux';
import {resetPassword} from '../../../redux/actions/authActions';
import {useParams} from 'react-router-dom';

const PasswordChange = () => {
    const {resetToken} = useParams()
    const [success, setSuccess] = useState("");
    const [failure, setFailure] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();

    const resetPasswordSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        const validate = validatePassword(password, confirmPassword);
        if(validate){
            const data = {
                password: password,
                resetToken: resetToken
            }
            const response = await dispatch(resetPassword(data));
            if(response.status === 200){
                setSuccess("Password has been updated successfully !!");
                setFailure("");
                setPassword("");
                setConfirmPassword("");
            }else{
                const errorMessage = response.data.errorMessage || "Something went wrong !!";
                setFailure(errorMessage);
                setSuccess("");
            }

        }else{
            setFailure("Password should match");
        }
        setIsLoading(false);
    }

    const validatePassword = (password, confirm) => {
        if(password===confirm) {
            return true;
        }
        return false;
    }

    return (
        <div className='w-100'>
            <Navbar />
            <div className={`w-50 mx-auto p-5`}>
                <h3 className='text-center'>
                    Reset Password Form
                </h3>
                {
                    success ? 
                    (
                        <div className="alert alert-success alert-dismissible fade show" role="alert">
                            {success}
                        <button type="button" className="btn-close" onClick = {() => setSuccess("")} data-bs-dismiss="alert" aria-label="Close"></button>
                      </div>
                    ) : 
                    <></>
                }
                 {
                    failure ? 
                    (
                        <div className="alert alert-danger alert-dismissible fade show" role="alert">
                            {failure}
                            <button type="button" className="btn-close"  onClick = {() => setFailure("")} data-bs-dismiss="alert" aria-label="Close">

                            </button>
                        </div>
                    ) : 
                    <></>
                }
                <form onSubmit={resetPasswordSubmit}>
                    <div className='form-group mt-5'>
                        <input className="form-control w-100" 
                        type='password' 
                        placeholder="Enter the password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)} />
                    </div>
                    <div className='form-group mt-5'>
                        <input className="form-control w-100" 
                        type='password' 
                        placeholder="Enter the confirm password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)} />
                    </div>
                    <div className='form-group mt-5'>
                        <button className='btn btn-primary w-100' disabled={isLoading}>
                            {
                                isLoading ?
                                <CircularSpinner /> :
                                <div>Submit</div>
                            }
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default PasswordChange
